import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const SLIDE_WIDTH_PC = 280;
const SLIDE_WIDTH_SP = 160;
const SPACE = 20;
const SM_BREAKPOINT = 640;

const blockLifestyle = () => {
    const el = document.querySelector('.js-lifestyle-swiper');
    if (!el) return;

    const wrapper = el.querySelector('.swiper-wrapper');
    const originalSlides = Array.from(el.querySelectorAll('.swiper-slide'));
    const originalCount = originalSlides.length;
    if (originalCount === 0) return;

    // コンテナ幅に対してスライドが足りない場合はクローンして補充
    // 幅はページごとにCSSで変わるため、実寸を優先して取得する
    const slideWidth =
        originalSlides[0].offsetWidth ||
        (window.innerWidth <= SM_BREAKPOINT ? SLIDE_WIDTH_SP : SLIDE_WIDTH_PC);
    const visibleCount = Math.ceil((el.offsetWidth + SPACE) / (slideWidth + SPACE));
    const minRequired = visibleCount * 2;

    if (originalCount < minRequired) {
        const times = Math.ceil(minRequired / originalCount);
        for (let i = 1; i < times; i++) {
            originalSlides.forEach(slide => {
                wrapper.appendChild(slide.cloneNode(true));
            });
        }
    }

    const paginationEl = el
        .closest('.c-others-block-lifestyle')
        ?.querySelector('.js-lifestyle-pagination');

    const swiper = new Swiper(el, {
        modules: [Autoplay],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: SPACE,
        centeredSlides: false,
        slideToClickedSlide: false,
        watchOverflow: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
    });

    if (!paginationEl) return;

    // ページネーションをオリジナル数分だけ手動で構築
    const bullets = [];
    for (let i = 0; i < originalCount; i++) {
        const bullet = document.createElement('span');
        bullet.className = 'swiper-pagination-bullet';
        bullet.dataset.index = String(i);
        paginationEl.appendChild(bullet);
        bullets.push(bullet);
    }

    const updateActiveBullet = () => {
        const activeIdx = swiper.realIndex % originalCount;
        bullets.forEach((b, i) => {
            b.classList.toggle('swiper-pagination-bullet-active', i === activeIdx);
        });
    };

    swiper.on('slideChange', updateActiveBullet);
    updateActiveBullet();

    paginationEl.addEventListener('click', event => {
        const bullet = event.target.closest('.swiper-pagination-bullet');
        if (!bullet) return;
        const index = Number.parseInt(bullet.dataset.index ?? '', 10);
        if (Number.isNaN(index)) return;
        swiper.slideToLoop(index);
    });
};

export default blockLifestyle;
